import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { TaxCategoryType } from './types'

interface EditProps {
  tax_category: TaxCategoryType
}

export default function Edit({ tax_category }: EditProps) {
  return (
    <>
      <Head title="Editing tax category" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Editing tax category</h1>

        <Form
          tax_category={tax_category}
          action={`/tax_categories/${tax_category.id}`}
          method="patch"
          submitText="Update Tax category"
        />

        <Link
          href={`/tax_categories/${tax_category.id}`}
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Show this tax category
        </Link>
        <Link
          href="/tax_categories"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Back to tax categories
        </Link>
      </div>
    </>
  )
}
